import { render, staticRenderFns } from "./AiAuditTask.vue?vue&type=template&id=2de492d6&scoped=true&"
import script from "./AiAuditTask.vue?vue&type=script&lang=js&"
export * from "./AiAuditTask.vue?vue&type=script&lang=js&"
import style0 from "./AiAuditTask.vue?vue&type=style&index=0&id=2de492d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de492d6",
  null
  
)

export default component.exports